export default (function (doc) {
  if (doc === void 0) {
    doc = document;
  }

  return doc.activeElement;
});